import { List, ListGroup, ListItem } from 'framework7-react';
import { FC } from 'react';

import dayjs from 'dayjs';

import { FeedEvent } from '@queries/EventQueries';

import { useNavigate } from '@router/index';

import { EntertainerScheduleDateDetail } from '@screens/entertainer/DragKingCommunityScreen/ScheduledSocialPost';

import { EntertainerScheduleDateDetailListItem, ShowListItem } from './ShowListItem';
import { useJoinLineup } from './ShowsTabContent';

type ScheduleDateDetail = Omit<EntertainerScheduleDateDetail, 'entertainer'> &
  Partial<Pick<EntertainerScheduleDateDetail, 'entertainer'>>;

const isFeedEvent = (event: FeedEvent | ScheduleDateDetail): event is FeedEvent => {
  return !!(event as FeedEvent)?._id;
};

export const ShowsList: FC<{
  className?: string;
  cityId: string;
  showsGroupedByStartDate?: Record<string, (FeedEvent | ScheduleDateDetail)[]>;
  showsGroupedBySectionTitle?: Record<string, (FeedEvent | ScheduleDateDetail)[]>;
  back: string;
  currentSuggestion?: { payload: { like: string[] }; iconUrl: string };
  hideEntertainerMenuButton?: boolean;
  primaryEntertainerType?: 'comedian' | 'dj' | 'dragPerformer';
  onAddExternalLink?: (show: FeedEvent | ScheduleDateDetail) => void;
}> = ({
  className,
  cityId,
  showsGroupedByStartDate,
  showsGroupedBySectionTitle,
  back,
  currentSuggestion,
  hideEntertainerMenuButton,
  primaryEntertainerType,
  onAddExternalLink,
}) => {
  const navigate = useNavigate();

  const handleNavigateToEvent = (eventId: string) => {
    navigate(`/events/${eventId}/reviews`, {
      state: { back },
    });
  };

  const { handleJoinLineup } = useJoinLineup({ cityId, primaryEntertainerType });

  return (
    <List className={className} mediaList style={{ marginLeft: -16, marginRight: -16 }}>
      {showsGroupedBySectionTitle
        ? Object.entries(showsGroupedBySectionTitle).map(([sectionTitle, groupedEvents]) => (
            <ListGroup key={sectionTitle}>
              <ListItem title={sectionTitle} groupTitle />
              {groupedEvents.map((event) =>
                isFeedEvent(event) ? (
                  <ShowListItem
                    key={event._id}
                    event={event}
                    onNavigate={() => handleNavigateToEvent(event._id)}
                    onJoin={(cb) => handleJoinLineup(event._id, cb)}
                    suggestion={currentSuggestion}
                    hideEntertainerMenuButton={hideEntertainerMenuButton}
                    onAddExternalLink={onAddExternalLink}
                  />
                ) : (
                  <EntertainerScheduleDateDetailListItem
                    key={`${event?.entertainer?._id}-${event?.dateDetails?.showName ?? ''}`}
                    entertainerScheduleDateDetail={event}
                    onClick={() => {}}
                  />
                ),
              )}
            </ListGroup>
          ))
        : !!showsGroupedByStartDate &&
          Object.entries(showsGroupedByStartDate).map(([date, groupedEvents]) => (
            <ListGroup key={date}>
              <ListItem title={dayjs(date).format('dddd, MMMM D, YYYY')} groupTitle />
              {groupedEvents.map((event) =>
                isFeedEvent(event) ? (
                  <ShowListItem
                    key={event._id}
                    event={event}
                    onNavigate={() => handleNavigateToEvent(event._id)}
                    onJoin={(cb) => handleJoinLineup(event._id, cb)}
                    suggestion={currentSuggestion}
                    hideEntertainerMenuButton={hideEntertainerMenuButton}
                    onAddExternalLink={onAddExternalLink}
                  />
                ) : (
                  <EntertainerScheduleDateDetailListItem
                    key={`${event?.entertainer?._id}-${event?.dateDetails?.showName ?? ''}`}
                    entertainerScheduleDateDetail={event}
                    onClick={() => {}}
                  />
                ),
              )}
            </ListGroup>
          ))}
    </List>
  );
};
